import { render } from "./DedicatedVirtualAccountForm.vue?vue&type=template&id=691372a1&scoped=true"
import script from "./DedicatedVirtualAccountForm.vue?vue&type=script&lang=js"
export * from "./DedicatedVirtualAccountForm.vue?vue&type=script&lang=js"

import "./DedicatedVirtualAccountForm.vue?vue&type=style&index=0&id=691372a1&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691372a1"]])

export default __exports__